import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@veracity/vui'
import { useNavigate } from 'react-router-dom'

import { projectsClient, scenariosClient } from '@/api'
import { CloneScenarioRequest, ScenarioTags } from '@/interfaces'

const BASE_QUERY_KEY = projectsClient.QUERY_KEY

export const useProjectScenario = (projectId: number, scenarioId: number) => {
  const QUERY_KEY = [...BASE_QUERY_KEY, projectId]

  const { showSuccess } = useToast()
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const removeScenarioMutation = useMutation({
    mutationFn: () => scenariosClient.removeById(scenarioId),
    onSuccess: async () => {
      showSuccess('Scenario successfully removed')
      await queryClient.invalidateQueries({ queryKey: QUERY_KEY })
    }
  })

  const cloneScenarioMutation = useMutation({
    mutationFn: (req: CloneScenarioRequest) =>
      scenariosClient.clone(scenarioId, req),
    onSuccess: (clonedScenarioId: number) => {
      showSuccess('Scenario successfully cloned')
      navigate(`/projects/${projectId}/scenarios/${clonedScenarioId}`)
    }
  })

  const updateScenarioTagMutation = useMutation({
    mutationFn: (tag: ScenarioTags) =>
      scenariosClient.updateTag(scenarioId, tag),
    onSuccess: async () => {
      showSuccess('Scenario successfully updated 2')
      await queryClient.invalidateQueries({ queryKey: QUERY_KEY, stale: true })
    }
  })

  return {
    removeScenario: removeScenarioMutation.mutate,
    isRemoveScenarioInProgress: removeScenarioMutation.isPending,
    cloneScenario: cloneScenarioMutation.mutate,
    isCloneScenarioInProgress: cloneScenarioMutation.isPending,
    updateScenarioTag: updateScenarioTagMutation.mutate,
    isUpdateScenarioTagInProgress: updateScenarioTagMutation.isPending
  }
}
